module.exports = __webpack_public_path__ + "img/copy-grey-icon.f1112c92.svg";